import React, {Component} from 'react'
import LoadingHOC from './LoadingHOC'
import '../styles/main.css'

class List extends Component{
  render(){
    const{usernames} = this.props
    return(
      <ul>
        {usernames.map(user => <li key={user.id}>{user.name}</li>)}
      </ul>
    )
  }
}

export default LoadingHOC(List)



// WEBPACK FOOTER //
// ./src/components/List.js